import "@arco-design/web-react/es/Link/style";
import _Link from "@arco-design/web-react/es/Link";
import "@arco-design/web-react/es/Table/style";
import _Table from "@arco-design/web-react/es/Table";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconLeft from "@arco-design/web-react/icon/react-icon/IconLeft";
import "@arco-design/web-react/es/Tabs/style";
import _Tabs from "@arco-design/web-react/es/Tabs";
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import MermaidChart from '../MermaidChart';
import styles from '../style/index.module.less';
const TabPane = _Tabs.TabPane;
const statusTabs = [{
  key: 'sales',
  title: '销售单',
  chart: `stateDiagram-v2
    [*] --> 草稿 : 新建
    草稿 --> 待审批 : 发布
    草稿 --> [*] : 删除
    待审批 --> 已批准 : 审批通过
    待审批 --> 已驳回 : 审批驳回
    已驳回 --> 待审批 : 修改后重新发布
    已批准 --> 已生效 : MRP 派生完成
    已生效 --> 已生效 : 变更（新版本）`,
  columns: [{
    title: '状态',
    dataIndex: 'status'
  }, {
    title: '含义',
    dataIndex: 'meaning'
  }, {
    title: '可用操作',
    dataIndex: 'action'
  }],
  data: [{
    status: '草稿',
    meaning: '刚创建，未提交',
    action: '编辑、发布、删除'
  }, {
    status: '待审批',
    meaning: '等待审批人处理',
    action: '等待（可撤销）'
  }, {
    status: '已批准',
    meaning: '审批通过',
    action: '系统自动触发 MRP'
  }, {
    status: '已驳回',
    meaning: '审批退回',
    action: '修改后重新发布'
  }, {
    status: '已生效',
    meaning: '已派生计划，进入执行',
    action: '变更'
  }],
  link: '/help/sales',
  linkText: '销售指南'
}, {
  key: 'demand',
  title: '需求单',
  chart: `stateDiagram-v2
    [*] --> 草稿 : 新建
    草稿 --> 待审批 : 发布
    草稿 --> [*] : 删除
    待审批 --> 已批准 : 审批通过
    待审批 --> 已驳回 : 审批驳回
    已驳回 --> 待审批 : 修改后重新发布
    已批准 --> 已完成 : 计划已派生`,
  columns: [{
    title: '状态',
    dataIndex: 'status'
  }, {
    title: '含义',
    dataIndex: 'meaning'
  }, {
    title: '可用操作',
    dataIndex: 'action'
  }],
  data: [{
    status: '草稿',
    meaning: '刚创建',
    action: '编辑明细、发布、删除'
  }, {
    status: '待审批',
    meaning: '等待审批',
    action: '等待（可撤销）'
  }, {
    status: '已批准',
    meaning: '审批通过，MRP 运算中',
    action: '等待'
  }, {
    status: '已驳回',
    meaning: '审批退回',
    action: '修改后重新发布'
  }, {
    status: '已完成',
    meaning: '采购/生产任务已生成',
    action: '只读查看'
  }],
  link: '/help/demand',
  linkText: '需求指南'
}, {
  key: 'purchase',
  title: '采购订单',
  chart: `stateDiagram-v2
    [*] --> 草稿 : 新建
    草稿 --> 磋商中 : 发布
    草稿 --> [*] : 删除
    磋商中 --> 已确认 : 双方达成一致
    磋商中 --> 草稿 : 撤销
    已确认 --> 已确认 : 变更（新版本）`,
  columns: [{
    title: '状态',
    dataIndex: 'status'
  }, {
    title: '含义',
    dataIndex: 'meaning'
  }, {
    title: '可用操作',
    dataIndex: 'action'
  }],
  data: [{
    status: '草稿',
    meaning: '刚创建',
    action: '编辑物料/价格、发布、删除'
  }, {
    status: '磋商中',
    meaning: '已发供应商，等待确认',
    action: '出价、改价、撤销'
  }, {
    status: '已确认',
    meaning: '双方达成一致',
    action: '供应商可发货、可变更'
  }],
  link: '/help/purchase',
  linkText: '采购指南 | 供应商指南'
}, {
  key: 'produce',
  title: '工单',
  chart: `stateDiagram-v2
    [*] --> 草稿 : MRP 创建 / 手工创建
    草稿 --> 有效 : 开工
    有效 --> 暂停 : 暂停
    暂停 --> 有效 : 恢复
    有效 --> 完工 : 完工（归档冻结）
    有效 --> 无效 : 关闭
    完工 --> 有效 : 返工出库`,
  columns: [{
    title: '状态',
    dataIndex: 'status'
  }, {
    title: '含义',
    dataIndex: 'meaning'
  }, {
    title: '可用操作',
    dataIndex: 'action'
  }],
  data: [{
    status: '草稿',
    meaning: '已创建未开始',
    action: '查看、删除'
  }, {
    status: '有效（生产中）',
    meaning: '正在生产',
    action: '领料、补料、暂停、完工、关闭'
  }, {
    status: '暂停',
    meaning: '临时停工',
    action: '恢复'
  }, {
    status: '完工',
    meaning: '归档冻结',
    action: '只读查看'
  }, {
    status: '无效',
    meaning: '已关闭',
    action: '只读查看'
  }],
  link: '/help/production',
  linkText: '生产指南'
}, {
  key: 'ecn',
  title: 'ECN 工程变更单',
  chart: `stateDiagram-v2
    [*] --> 草稿 : 新建
    草稿 --> 待审批 : 发布
    草稿 --> [*] : 删除
    待审批 --> 已批准 : 审批通过（执行变更）
    待审批 --> 已驳回 : 审批驳回
    已驳回 --> 待审批 : 修改后重新发布`,
  columns: [{
    title: '状态',
    dataIndex: 'status'
  }, {
    title: '含义',
    dataIndex: 'meaning'
  }, {
    title: '可用操作',
    dataIndex: 'action'
  }],
  data: [{
    status: '草稿',
    meaning: '刚创建',
    action: '编辑明细、发布、删除'
  }, {
    status: '待审批',
    meaning: '等待审批',
    action: '等待（可撤回）'
  }, {
    status: '已批准',
    meaning: '变更已执行',
    action: '只读查看'
  }, {
    status: '已驳回',
    meaning: '审批退回',
    action: '修改后重新发布'
  }],
  link: '/help/production',
  linkText: '生产指南 - ECN'
}, {
  key: 'statement',
  title: '对账单',
  chart: `stateDiagram-v2
    [*] --> 草稿 : 系统自动生成
    草稿 --> 已发布 : 发布
    已发布 --> 已确认 : 双方确认一致
    已发布 --> 已驳回 : 对方驳回
    已驳回 --> 已发布 : 调整后重新发布
    已确认 --> 已付款 : 付款完成`,
  columns: [{
    title: '状态',
    dataIndex: 'status'
  }, {
    title: '含义',
    dataIndex: 'meaning'
  }, {
    title: '可用操作',
    dataIndex: 'action'
  }],
  data: [{
    status: '草稿',
    meaning: '系统根据收货明细生成',
    action: '查看明细、发布'
  }, {
    status: '已发布',
    meaning: '已发给对方确认',
    action: '等待'
  }, {
    status: '已确认',
    meaning: '双方核对一致',
    action: '创建付款单'
  }, {
    status: '已驳回',
    meaning: '对方有异议',
    action: '调整后重新发布'
  }, {
    status: '已付款',
    meaning: '付款完成',
    action: '只读查看'
  }],
  link: '/help/finance',
  linkText: '财务指南'
}, {
  key: 'payment',
  title: '付款单',
  chart: `stateDiagram-v2
    [*] --> 草稿 : 对账单自动派生
    草稿 --> 待审批 : 发布
    草稿 --> [*] : 删除
    待审批 --> 已审批 : 审批通过
    待审批 --> 已驳回 : 审批驳回
    已驳回 --> 待审批 : 修改后重新发布
    已审批 --> 已确认 : 财务确认
    已确认 --> 已完成 : 付款完成`,
  columns: [{
    title: '状态',
    dataIndex: 'status'
  }, {
    title: '含义',
    dataIndex: 'meaning'
  }, {
    title: '可用操作',
    dataIndex: 'action'
  }],
  data: [{
    status: '草稿',
    meaning: '对账确认后自动创建',
    action: '发布、删除'
  }, {
    status: '待审批',
    meaning: '等待审批',
    action: '等待（可撤销）'
  }, {
    status: '已审批',
    meaning: '审批通过',
    action: '确认付款'
  }, {
    status: '已驳回',
    meaning: '审批退回',
    action: '修改后重新发布'
  }, {
    status: '已确认',
    meaning: '财务确认待付款',
    action: '完成付款'
  }, {
    status: '已完成',
    meaning: '付款完成',
    action: '只读查看'
  }],
  link: '/help/finance',
  linkText: '财务指南 - 付款'
}, {
  key: 'expense',
  title: '费用项',
  chart: `stateDiagram-v2
    [*] --> 未确认 : 任一方创建
    未确认 --> 已确认 : 对方确认同意
    未确认 --> [*] : 创建方删除
    已确认 --> [*] : 纳入对账结算`,
  columns: [{
    title: '状态',
    dataIndex: 'status'
  }, {
    title: '含义',
    dataIndex: 'meaning'
  }, {
    title: '可用操作',
    dataIndex: 'action'
  }],
  data: [{
    status: '未确认',
    meaning: '刚创建，待对方确认',
    action: '对方确认、创建方删除'
  }, {
    status: '已确认',
    meaning: '双方确认一致',
    action: '纳入对账单结算'
  }],
  link: '/help/finance',
  linkText: '财务指南 - 费用'
}];
export default function Status() {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState('sales');
  const current = statusTabs.find(t => t.key === activeTab) || statusTabs[0];
  return /*#__PURE__*/React.createElement("div", {
    className: styles['status-page']
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    icon: /*#__PURE__*/React.createElement(_IconLeft, null),
    onClick: () => history.push('/help')
  }, "\u8FD4\u56DE\u5E2E\u52A9\u4E2D\u5FC3")), /*#__PURE__*/React.createElement("h1", {
    className: styles['status-page-title']
  }, "\u72B6\u6001\u6D41\u8F6C\u901F\u67E5"), /*#__PURE__*/React.createElement(_Tabs, {
    type: "rounded",
    activeTab: activeTab,
    onChange: setActiveTab
  }, statusTabs.map(tab => /*#__PURE__*/React.createElement(TabPane, {
    key: tab.key,
    title: tab.title
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['status-tab-content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['status-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: tab.chart
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: tab.columns,
    data: tab.data,
    pagination: false,
    size: "default",
    border: true
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['status-link']
  }, "\u8BE6\u7EC6\u64CD\u4F5C\u6307\u5F15 \u2192", ' ', /*#__PURE__*/React.createElement(_Link, {
    onClick: () => history.push(tab.link)
  }, tab.linkText)))))));
}